import { useTranslation } from '@wix/wix-i18n-config';
import { Loader } from '@wix/design-system';
import cs from 'classnames';
import React from 'react';

import { templatePreviewModalDataHooks } from '../TemplatePreviewModal.dataHooks';
import s from './PreviewHeader.scss';
import WixStudioLogo from './WixStudioLogo.svg';
import Desktop from './Desktop.svg';

type Props = {
  onButtonClick: () => void;
  isLoading?: boolean;
};

export const PreviewHeader: React.FC<Props> = ({
  onButtonClick,
  isLoading,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <div
        className={s.previewHeader}
        data-hook={templatePreviewModalDataHooks.previewHeader()}
      >
        <WixStudioLogo className={s.logo} />
        <button
          onClick={onButtonClick}
          disabled={isLoading}
          className={cs(s.button, s.buttonWrap)}
        >
          {isLoading && (
            <span className={s.buttonLoader}>
              <Loader size="tiny" />
            </span>
          )}
          <span className={cs({ [s.buttonLabelHidden]: isLoading })}>
            {t('app.templates.saveTemplate.saveButton.text')}
          </span>
        </button>
      </div>
      <div className={s.goToDesktop}>
        <Desktop />
        <div>{t('app.template.viewer.goToBiggerScreen')}</div>
      </div>
    </>
  );
};
